import React from "react";
import { Badge } from "@/components/ui/badge";
import { RefuelData } from "@/interface/entityInterface";
import { sheet } from "@/interface/dataInterface";
import CommonDetailsDialog from "@/components/common/details/DetailsDialog";
import {
  Table,
  TableHeader,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
} from "@/components/ui/table";
import Header from "../components/Header";

interface RefuelDetailsSheetProps extends sheet {
  refuel: RefuelData | null;
}

export const RefuelDetails: React.FC<RefuelDetailsSheetProps> = ({
  refuel,
  open,
  setOpen,
}) => {
  if (!refuel) return null;

  return (
    <CommonDetailsDialog
      open={open}
      setOpen={setOpen}
      title="refuel details"
      description={`Total breakdown of refuel # ${refuel.id}`}
    >
      <div className="w-full max-w-2xl mx-auto bg-background shadow-md overflow-hidden sm:rounded-lg">
        <div className="px-6 py-4 space-y-6">
          <Header
            date={refuel.date}
            odometer={refuel.odometer}
            vehicle={refuel.vehicle}
          />
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Name</TableHead>
                <TableHead className="text-center">Liters(L)</TableHead>
                <TableHead className="text-right">Price($)</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {refuel.refueling_tanks.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>
                    <Badge>{item.fuel.name}</Badge>
                  </TableCell>
                  <TableCell className="text-center">
                    {item.unit_value}
                  </TableCell>
                  <TableCell className="text-right">{item.total_cost}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div>{refuel.notes}</div>
        </div>
      </div>
    </CommonDetailsDialog>
  );
};
